import { fetcher } from '@/services/api'
import { authRoutes } from '@/services/auth/auth.service'
import useSWR from 'swr'
import { User } from '@/types/models/User'

interface Props {
  authenticated: boolean
}

export function useAuthMe({ authenticated }: Props) {
  const { data, error, mutate, isLoading } = useSWR(
    () => (authenticated ? [authRoutes.getMe] : undefined),
    fetcher<User>,
    {
      revalidateIfStale: true,
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
      suspense: false,
      shouldRetryOnError: true,
    }
  )

  return {
    user: data,
    refresh: mutate,
    isLoading,
    isError: error,
  }
}
